<template>
  <transition name="fade-scale">
    <div v-if="messages.length" class="c-toast-notifications">
      <transition-group
        tag="div"
        class="c-toast-notifications__wrapper"
        mode="out-in"
        appear
        name="fade-scale"
      >
        <div
          v-for="{ id, message, severity } in messages"
          :key="id"
          class="c-toast-notifications__item"
          :class="severity"
          @click="clear(id)"
        >
          <i :class="getIcon(severity)" class="fa-lg"></i>
          <span>
            {{ message }}
          </span>
        </div>
      </transition-group>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import eventBus from '../../plugins/eventBus';

export default {
  data() {
    return {
      defaultSuccessMessage: undefined,
      index: 0,
      messages: []
    };
  },
  computed: {
    ...mapState(['culture']),
    ...mapGetters('translations', { L: 'getToastNotificationTranslations' })
  },
  mounted() {
    eventBus.$on('notify', this.notify);
  },
  methods: {
    ...mapActions('translations', ['getTranslations']),
    clear(id) {
      this.messages = this.messages.filter(x => x.id !== id);
    },
    async notify(options) {
      const id = this.index++;

      if (!options.message && !this.defaultSuccessMessage) {
        this.defaultSuccessMessage = await this.getDefaultMessage();
      }

      this.messages.push({
        id,
        message: options.message ?? this.defaultSuccessMessage,
        severity: options.severity
      });

      if (options.duration) {
        setTimeout(() => {
          this.clear(id);
        }, options.duration);
      }
    },
    getIcon(severity) {
      switch (severity) {
        case 'success':
          return 'far fa-info-circle';
        case 'error':
          return 'far fa-times-circle';
        case 'info':
          return 'far fa-info-circle';
        case 'warning':
          return 'far fa-exclamation-triangle';
        default:
          return 'far fa-question';
      }
    },
    async getDefaultMessage() {
      await this.getTranslations({
        culture: this.culture,
        dictionaryKey: 'ToastNotification'
      });
      return this.L['ToastNotification.Success'];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-toast-notifications {
  position: fixed;
  bottom: 40px;
  right: 40px;
  bottom: 40px;
  z-index: 999;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  &__item {
    color: $white;
    background-color: $grey;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    max-width: 300px;
    margin-top: 10px;
    padding: 12px 15px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    &.success {
      background-color: $success-light;
    }

    &.error {
      background-color: $danger;
    }

    &.warning {
      background-color: $warning;
    }
  }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: opacity 200ms ease, transform 200ms ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
